import { useId } from "react";

export const PRODUCT = { name: "Qayd", tagline: "ERP for growing businesses", arabic: "قيد" };

/**
 * Qayd mark: a "Q" whose tail runs into a ledger line.
 * Qayd (قيد) means "journal entry", the starting point of every set of books.
 */
export function QaydMark({ size = 28, title = PRODUCT.name, style }) {
  const id = useId();
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" role="img" aria-label={title} style={{ flexShrink: 0, ...style }}>
      <defs>
        <linearGradient id={`${id}-g`} x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#7c7cf5" />
          <stop offset="1" stopColor="#4646c8" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="8" fill={`url(#${id}-g)`} />
      <circle cx="15" cy="14.5" r="7" fill="none" stroke="#fff" strokeWidth="3" />
      <path d="M18.5 18.5 L24.5 24.5" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
      <path d="M7 24.5 H15" stroke="#fff" strokeOpacity="0.55" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

/** Mark + wordmark. `tone="white"` for dark surfaces. */
export function QaydLogo({ tone = "dark", subtitle, size = 30 }) {
  const white = tone === "white";
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 10 }}>
      <QaydMark size={size} />
      <span style={{ lineHeight: 1 }}>
        <span style={{ display: "block", fontSize: 19, fontWeight: 650, letterSpacing: "-0.02em", color: white ? "#fff" : "#111114" }}>
          {PRODUCT.name}
        </span>
        {subtitle && (
          <span style={{ display: "block", marginTop: 4, fontSize: 11, fontWeight: 500, color: white ? "rgba(255,255,255,0.5)" : "#8f929b" }}>
            {subtitle}
          </span>
        )}
      </span>
    </span>
  );
}
